var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayoutGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 8.33317H3.33329C2.41246 8.33317 1.66663 7.58734 1.66663 6.6665V3.33317C1.66663 2.41234 2.41246 1.6665 3.33329 1.6665H6.66663C7.58746 1.6665 8.33329 2.41234 8.33329 3.33317V6.6665C8.33329 7.58734 7.58746 8.33317 6.66663 8.33317Z",
    stroke: "#FEFCEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 8.33317H13.3333C12.4125 8.33317 11.6666 7.58734 11.6666 6.6665V3.33317C11.6666 2.41234 12.4125 1.6665 13.3333 1.6665H16.6666C17.5875 1.6665 18.3333 2.41234 18.3333 3.33317V6.6665C18.3333 7.58734 17.5875 8.33317 16.6666 8.33317Z",
    stroke: "#FEFCEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 18.3332H3.33329C2.41246 18.3332 1.66663 17.5873 1.66663 16.6665V13.3332C1.66663 12.4123 2.41246 11.6665 3.33329 11.6665H6.66663C7.58746 11.6665 8.33329 12.4123 8.33329 13.3332V16.6665C8.33329 17.5873 7.58746 18.3332 6.66663 18.3332Z",
    stroke: "#FEFCEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 18.3332H13.3333C12.4125 18.3332 11.6666 17.5873 11.6666 16.6665V13.3332C11.6666 12.4123 12.4125 11.6665 13.3333 11.6665H16.6666C17.5875 11.6665 18.3333 12.4123 18.3333 13.3332V16.6665C18.3333 17.5873 17.5875 18.3332 16.6666 18.3332Z",
    stroke: "#FEFCEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutGrid);
export default __webpack_public_path__ + "static/media/layout-grid.0e0ddbcaae293b377862e80d5f7929db.svg";
export { ForwardRef as ReactComponent };